"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApi = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const api_1 = require("./api");
const StorageWithExpiration_1 = require("./StorageWithExpiration");
class BaseApi {
    constructor(config) {
        this.storageWithExpiration = null;
        this.currentPromise = null;
        this.config = config;
        this.initializeStorageWithExpiration();
    }
    getData(params = null) {
        const cachedData = this.getStoredData(params);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
        return this.loadData(params);
    }
    loadData(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApi(this.config.url, params);
            this.setDataToStorage(data, params);
            return data;
        });
    }
    callApi(url, params) {
        const countryHeaders = {};
        if (this.waitForInProgress() && this.currentPromise) {
            return this.currentPromise;
        }
        if (this.config.locationApiKey) {
            countryHeaders['x-api-key'] = this.config.locationApiKey;
        }
        const headers = Object.assign(Object.assign({}, this.createHeaders()), countryHeaders);
        // for Application Insights
        const startTime = Date.now();
        this.currentPromise = (0, api_1.api)(url, params, headers)
            .then(response => {
            this.currentPromise = null;
            if (response.status !== 200) {
                this.throwException(response.statusText, response);
            }
            return response;
        })
            .then(response => {
            this.trackApiCall(response, headers, url, startTime);
            return response.data;
        })
            .catch(reason => {
            this.currentPromise = null;
            this.throwException(reason.message, reason.response);
        });
        return this.currentPromise;
    }
    getStoredData(params) {
        let result = null;
        if (this.canUseStorage()) {
            const jsonData = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
            result = this.deserialize(jsonData, params);
        }
        return result;
    }
    setDataToStorage(data, params) {
        if (this.canUseStorage()) {
            const dataToStore = this.serialize(data, params);
            if (dataToStore) {
                const { storageKey, storageExpirationTime } = this.config;
                this.storageWithExpiration.setDataToStorage(storageKey, dataToStore, storageExpirationTime);
            }
        }
    }
    initializeStorageWithExpiration() {
        if (this.config && this.config.storage) {
            this.storageWithExpiration = new StorageWithExpiration_1.default(this.config.storage);
        }
    }
    canUseStorage() {
        return this.storageWithExpiration && !!this.config.storageKey;
    }
    waitForInProgress() {
        return this.config && this.config.waitForInProgress;
    }
    throwException(message, responseData, name = '') {
        const apiError = new Error(message);
        apiError.name = name;
        apiError.responseData = responseData;
        throw apiError;
    }
    createHeaders() {
        return null;
    }
    serialize(data, _params) {
        return JSON.stringify(data);
    }
    deserialize(data, _params) {
        return app_1.JSONService.parse(data);
    }
    trackApiCall(response, headers, url, startTime) {
        if (headers &&
            typeof window !== 'undefined' &&
            'appInsights' in window &&
            'Microsoft' in window &&
            'AI' in window) {
            appInsights.trackDependency(Microsoft.ApplicationInsights.UtilHelpers.newId(), 'GET', url, `GET ${url}`, Date.now() - startTime, response.status === 200, response.status, {
                appTrack: true,
                requestId: headers.requestId,
            });
        }
    }
}
exports.default = BaseApi;
exports.BaseApi = BaseApi;
